import { render } from "./connectButton.vue?vue&type=template&id=04a2a735"
import script from "./connectButton.vue?vue&type=script&lang=js"
export * from "./connectButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__